import { supabase } from '../components/supabaseClient';

let warmupPromise = null;
let isWarmedUp = false;

/**
 * Warms up the Supabase connection with a lightweight query
 * This helps avoid cold start issues on the first real query
 */
export const warmupSupabaseConnection = async () => {
  // If already warming up or warmed up, return the existing promise
  if (warmupPromise) {
    return warmupPromise;
  }

  if (isWarmedUp) {
    return Promise.resolve();
  }

  warmupPromise = (async () => {
    try {
      console.log('[Supabase Warmup] Starting connection warmup...');
      const startTime = performance.now();
      
      // Execute a minimal query to establish the connection
      // Using a limit of 1 and selecting only the id column for minimal data transfer
      const { data, error } = await supabase
        .from('companies_processed')
        .select('id')
        .limit(1);
      
      const endTime = performance.now();
      const duration = Math.round(endTime - startTime);
      
      if (error) {
        console.error('[Supabase Warmup] Warmup query failed:', error);
        // Don't throw - we still want the app to work even if warmup fails
      } else {
        console.log(`[Supabase Warmup] Connection warmed up successfully in ${duration}ms`);
        isWarmedUp = true;
      }
    } catch (err) {
      console.error('[Supabase Warmup] Unexpected error during warmup:', err);
      // Don't throw - warmup is a performance optimization, not critical
    }
  })();

  return warmupPromise;
};

/**
 * Get the warmup status
 */
export const isConnectionWarmedUp = () => isWarmedUp;

/**
 * Reset warmup state (useful for testing)
 */
export const resetWarmupState = () => {
  warmupPromise = null;
  isWarmedUp = false;
};